<template>
    <div class="login">
        <div class="formContent">
            <div class="login-master">
                <div class="login-title text-center">U盟商城管理后台</div>
                <el-form label-width="60px">
                  <el-form-item label="账号:">
                    <el-input placeholder="请输入账号" v-model="username"></el-input>
                  </el-form-item>
                  <el-form-item label="密码:">
                    <el-input placeholder="请输入密码" v-model="password" type="password"></el-input>
                  </el-form-item>
                   <el-button type="primary" @click="Login">登录</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {loginIN} from 'api/request'
import { mapMutations } from 'vuex'
import { Success, Error } from 'common/js/util.js'
export default{
  data () {
    return {
      username: '',
      password: ''
    }
  },
  mounted () {
    /* let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (getUserInfo) {
      this.$router.push({
        path: '/user'
      })
    } */
  },
  methods: {
    Login () {
      let parameter = {
        userName: this.username,
        password: this.password
      }
      loginIN(parameter).then((res) => {
        let _this = this
        if (res.status === 200) {
          Success(this, res)
          var data = res.data;
          setTimeout(function () {
            var url = "";
            switch(data.permissions[0]){
              case "homeData":
                url = "/home";
                break;
              case "memberManage":
                url = "/user";
                break;
              case "productManage":
                url = "/product";
                break;
              case "productManage1":
                url = "/orders";
                break;  
              case "orderManage":
                url = "/orders";
                break;
              case "orgManage":
                url = "/supplier";
                break;
              case "roleManage":
                url = "/permission";
                break;
              case "financeManage":
                url = "/balance";
                break;
              case "systemManage":
                url = "/system";
                break;
            }
            _this.$router.push({
              path: url
            })
          }, 2000)
          window.localStorage.setItem("token",res.data.token)
          this.getUserInfo(res.data)
        } else {
          Error(this, res)
        }
      })
    },
    ...mapMutations({
      getUserInfo: 'GET_USER_INFO'
    })
  }
}
</script>
<style scoped>
    .text-center {
        text-align: center;
    }
    .login {
        z-index: 9;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background-color: #fffffff;
    }
    .login .formContent {
        width: 100%;
        height: 320px;
        background-color: #1097FB;
        text-align: center;
    }
    .login .formContent .login-master {
        width: 320px;
        padding-top: 50px;
        margin: 0 auto;
    }
    .login-master .login-title {
        margin-bottom: 40px;
        font-size: 20px;
        text-align: center;
        color: #FFFFFF;
    }
    .login .el-button{
      width: 70px;
      background-color: #FFFFFF;
      border-radius: 4px;
      color: #333333;
      text-align: center;
      display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue